export const KEEP_CONFIRMATION_MODAL_OPEN = Symbol('KEEP_CONFIRMATION_MODAL_OPEN');

export async function runConfirmationOption(onSelect: () => unknown, onClose: () => void): Promise<void> {
  const result = await onSelect();
  if (result !== KEEP_CONFIRMATION_MODAL_OPEN) {
    onClose();
  }
}
